import { render, staticRenderFns } from "./ModalPrint.vue?vue&type=template&id=0b6a745e"
import script from "./ModalPrint.vue?vue&type=script&lang=js"
export * from "./ModalPrint.vue?vue&type=script&lang=js"
import style0 from "./ModalPrint.vue?vue&type=style&index=0&id=0b6a745e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports